import { HTTP } from './httpCommon';

export const httpPost = {

  ////////////////////////////////////////////
  ///ACCOUNTS
  ////////////////////////////////////////////

  //Post Account
  postNewAccount(account, callback) {
    HTTP.post('Accounts',
      account
      )
      .then(response => {
        callback(response.status)
      })
      .catch(e => {
        //this.errors.push(e)
        console.log(e);
      })
      
  },


  ////////////////////////////////////////////
  ///INCOME
  ////////////////////////////////////////////

  //Post Income
  postNewIncome(income, callback) {
    HTTP.post('Incomes',
      income
    )
      .then(response => {
        callback(response.status)
      })
      .catch(e => {
        //this.errors.push(e)
        console.log(e);
      })
  },


  ////////////////////////////////////////////
  ///EXPENSE
  ////////////////////////////////////////////

  //Post Expense
  postNewExpense(expense, callback) {
    HTTP.post('Expenses',
      expense
    )
      .then(response => {
        callback(response.status)
      })
      .catch(e => {
        //this.errors.push(e)
        console.log(e);
      })
  },


  ////////////////////////////////////////////
  ///BUDGET
  ////////////////////////////////////////////

  //Post Budget
  postNewBudget(budget, callback) {
    HTTP.post('Budgets',
      budget
    )
      .then(response => { 
        callback(response.status)
      })
      .catch(e => {
        //this.errors.push(e)
        console.log(e);
      })
  },




}





// WEBPACK FOOTER //
// ./src/api/httpPost.js